import { useEffect, useState } from "react";
import "./side-navbar.css";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import TableRowsIcon from "@mui/icons-material/TableRows";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import {
  Snackbar,
  SnackbarContent,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

const SideNavbar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [text] = useState("makawitagemudith@gmail.com");

  const [open, setOpen] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setOpen(true);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handleCloseSnackbar = () => {
    setOpen(false);
  };

  const CV_LINK = "https://drive.google.com/file/d/1x0Bylv7v1AM5LZaM9QjwOwyI71-wT8Nn/view?usp=sharing"; // CV Link

  const viewCV = () => {
    window.open(CV_LINK, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className={`side-navbar ${isVisible ? "hidden" : "visible"}`}>
        <BootstrapTooltip title="LinkedIn" placement="left">
          <a
            className="side-link"
            href="https://www.linkedin.com/in/mudith-perera/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="side-items">
              <LinkedInIcon />
            </div>
          </a>
        </BootstrapTooltip>

        <BootstrapTooltip title="GitHub" placement="left">
          <a
            className="side-link"
            href="https://github.com/mudith-perera"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="side-items">
              <GitHubIcon />
            </div>
          </a>
        </BootstrapTooltip>

        <BootstrapTooltip title="Stack Overflow" placement="left">
          <a
            className="side-link"
            href="https://stackoverflow.com/users/11935228/mudith-perera"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="side-items">
              <TableRowsIcon />
            </div>
          </a>
        </BootstrapTooltip>

        <BootstrapTooltip title="Copy Email" placement="left">
          <div className="side-items" onClick={copyToClipboard}>
            <AlternateEmailIcon />
          </div>
        </BootstrapTooltip>
        <BootstrapTooltip title="View CV" placement="left">
          <div className="side-items" onClick={viewCV}>
            <img
              src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1729781487/cv-square_rikqcw.svg"
              alt="cv-icon"
              style={{ width: "25px", height: "25px" }}
            />
          </div>
        </BootstrapTooltip>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <SnackbarContent
          style={{
            backgroundColor: "var(--purple_c)",
          }}
          message={
            <span id="client-snackbar" className="snackbar-message">
              <CheckBoxIcon />
              <b> Email Copied to your clipboard!</b>{" "}
            </span>
          }
        />
      </Snackbar>
    </>
  );
};

export default SideNavbar;
